(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('FooterCtrl', ['$location', '$rootScope', '$scope', '$timeout', '$window', 'OrganizationSettings', 'wsConfig', 'User', 'wsEventNames', function ($location, $rootScope, $scope, $timeout, $window, OrganizationSettings, wsConfig, User, wsEventNames) {
    function isCardPage(path) {
      return path.indexOf("/dashboard/") >= 0 || path.indexOf("/card-group/") >= 0;
    }
    function isOutsidePage(path) {
      var outsidePages = ["unsubscribe", "automated-emails"];
      return outsidePages.reduce(function (curr, next) {
        return curr ? curr : path.includes(next);
      }, false);
    }
    function shouldHideFooterLink(url) {
      return isCardPage(url) || isOutsidePage(url);
    }
    $scope.hide = true;
    $scope.eventsFired = false;

    // Set initial visibility according to where we are
    $scope.hide = shouldHideFooterLink($location.path());

    // Update visibility based on where we're going next
    $rootScope.$on('$locationChangeStart', function (event, next) {
      $scope.hide = shouldHideFooterLink(next);
    });

    // On a card page, unhide when layout is complete (after small delay)
    $rootScope.$on(wsEventNames.cardDisplay.layoutComplete, _.debounce($scope.$safeApply.bind($scope, function () {
      $scope.eventsFired = true;
      $scope.hide = false;
    }), 250));
  }]);
})();
